import { MessageCircle } from "lucide-react";
import React from "react";

function CommentEmptyState() {
    return (
        <div className="text-center mt-8">
            <div className="icon-wrapper inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-50 text-primary mb-2">
                <MessageCircle />
            </div>

            <h2 className="text-2xl font-bold mb-2">No Comments Yet</h2>
            <p className="text-gray-500 max-w-md mx-auto">
                Be the first to share what you think! Your comments will appear here once you start the conversation.
            </p>
        </div>
    );
}

export default CommentEmptyState;
